export const constants = {
    environment: {
        DEVELOPMENT: 'development',
        LOCAL: 'local',
        RUSKIN:'Ruskin',
        PRODUCTION: 'production',
        QA: 'qa',
        SEL_NAV: 'selNav',
        STAGING: 'staging',
        UNIT_TEST: 'unitTest'
    },
    notificationType: {
        ERROR: 'error',
        INFO: 'info',
        SUCCESS: 'success',
        WARNING: 'warning'
    }
};
